module.exports = __webpack_public_path__ + "static/asperseur-gicleur-022b5ab3ae45cdc2739fa2e8483459fa.webm";